module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-Bold-41e5eae9.eot";